import PDFViewer from './components/PDFViewer';
import Image from '../Image/Image';
import type { File } from './types';

import styles from './FileEmbed.module.scss';

type FileEmbedProps = {
  resource: File;
};

const PDF_TYPE = 'application/pdf';
const IMAGE_JPEG_TYPE = 'image/jpeg';
const IMAGE_PNG_TYPE = 'image/png';
const UNSUPPORTED_FILE_LABEL = 'Unsupported file type';

const getFile = (resource: File) => {
  switch (resource.type) {
    case PDF_TYPE:
      return <PDFViewer file={resource} />;
    case IMAGE_JPEG_TYPE:
    case IMAGE_PNG_TYPE:
      return (
        <Image
          imageUrl={resource.url}
          width={resource.width || 700}
          height={resource.height || 450}
          alt={resource?.description || ''}
          className={styles.image}
        />
      );
    default:
      return <div className={styles.unsupported}>{UNSUPPORTED_FILE_LABEL}</div>;
  }
};

export const FileEmbed = ({ resource }: FileEmbedProps) => {
  return <div className={styles.container}>{getFile(resource)}</div>;
};
